import { Route } from "react-router-dom";
import lazyRoute from "@/router/lazy-route";

const WidgetLayout = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/widget/secondary-page-Book-appointment/WidgetLayout")
);

const WidgetRoute = () => {
  return <Route path="widget" index element={<WidgetLayout />}></Route>;
};

export default WidgetRoute;
